import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import { CartContext } from "../context/CartContext";
import { UserContext } from "../context/UserContext";
import axios from "axios";

const Navbar = ({ isSearching }) => {
  const auth = useContext(UserContext);
  const { logout } = useContext(UserContext);
  const { cart, setCart } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [searchResults, setSearchResults] = useState({
    products: [],
    categories: [],
    subcategories: [],
  });

  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  // Off canvous handle
  const handleClose = () => setShow(false);
  const handleShow = () => { setShow(true); auth.fetchUser(token) };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/all`
      );

      // Extract only the required fields from the response
      const processedProducts = response.data?.allProducts.map((product) => ({
        id: product.id,
        title: product.title,
        categories: product.categories, // Assuming this is an array
        subcategories: product.subcategories, // Assuming this is an array
        image: product.image[0] || null, // Taking the first image or null if no image exists
      }));

      setProducts(processedProducts); // Update the state with the processed data
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/categories`
      );
      setCategory(response?.data?.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getSubCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/allSubcategory`
      );

      if (response.status === 200 && response.data) {
        setSubCategory(response.data?.Subcategory);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
    getCategories();
    getSubCategories();
  }, []);

  // Handle search
  const handleSearch = (query) => {
    if (query.trim() === "") {
      // Clear the results if query is empty
      setSearchResults({ products: [], categories: [], subcategories: [] });
      return;
    }

    // Split the query into individual words and trim extra spaces
    const queryWords = query.toLowerCase().split(/\s+/);

    // Filter categories
    const filteredCategories = category.filter((cat) =>
      queryWords.some((word) => cat.name.toLowerCase().includes(word))
    );

    // Filter subcategories
    const filteredSubCategories = subCategory.filter((subCat) =>
      queryWords.some((word) => subCat.name.toLowerCase().includes(word))
    );

    // Collect category and subcategory IDs
    const categoryIds = filteredCategories.map((cat) => cat.id.toString());
    const subCategoryIds = filteredSubCategories.map((subCat) =>
      subCat.id.toString()
    );

    // Filter products based on title, categories, or subcategories
    const filteredProducts = products.filter((product) => {
      return (
        queryWords.some((word) => product.title.toLowerCase().includes(word)) ||
        product.categories.some((catId) => categoryIds.includes(catId)) ||
        product.subcategories.some((subCatId) =>
          subCategoryIds.includes(subCatId)
        )
      );
    });

    // Set the search results in a single state
    setSearchResults({
      products: filteredProducts,
      categories: filteredCategories,
      subcategories: filteredSubCategories,
    });
  };

  let debounceTimer;

  const handleInputChange = (e) => {
    const query = e.target.value; // Get the input value
    setSearchQuery(query); // Update the searchQuery state
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleSearch(query);
    }, 500);
  };

  const handleSearchButton = () => {
    if (searchQuery !== "") {
      navigate(`/search?query=${searchQuery}`);
      setSearchQuery("");
      setSearchResults({
        products: [],
        categories: [],
        subcategories: [],
      });
    }
  };

  // Menu toggle system
  function openMenu() {
    setMenuOpen(true);
  }

  function closeMenu() {
    setMenuOpen(false);
  }

  function toggleMenu() {
    if (menuOpen === false) {
      openMenu();
    } else {
      closeMenu();
    }
  }
  const formatProfileImageUrl = (url) => {
    if (!url) return ""; // Return empty if URL is undefined

    const urlArr = url.split("/");

    if (urlArr[2] === "backend.clicktokart.in") {
      url = url.replace("/upload/profilephoto/", "/src/upload/profilephoto/");
    }

    return url;
  };
  const profileImage = formatProfileImageUrl(auth?.user?.profilePhoto);

  const handleLogout = () => {
    // Clear the token
    localStorage.removeItem("token");
    localStorage.removeItem("email");

    localStorage.removeItem("userType");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("orderNumber");
    localStorage.removeItem("userInfo");

    // Clear the cart by setting it to an empty array
    setCart([]);

    // Execute your logout function (if it handles other clean-up tasks)
    logout();

    // Navigate to the home page after logging out
    navigate("/");
  };

  const userType = localStorage.getItem("userType");

  return (
    <>
      <div className="navbararea fixed-top">
        <nav className="navbar p-2">
          <Link to="/" className="brand-logo">
            <img
              src="https://tecdn.b-cdn.net/img/logo/te-transparent-noshadows.webp"
              style={{ height: "30px" }}
              alt="TE Logo"
              loading="lazy"
            />
          </Link>
          <div className="d-flex align-items-center justify-content-between border-1 formsecwid">
            {/* Search Section */}
            <div
              className={`collapsable-menu ${menuOpen === true ? "open-menu" : ""
                }`}
            >
              <form
                action=""
                className="search-form d-flex p-1 mx-3"
                onSubmit={(e) => e.preventDefault()} // Prevent form submission
              >
                <input
                  type="search"
                  className="search form-control shadow-none"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleInputChange}
                  onFocus={handleInputChange}
                />
                <button
                  className="search-btn"
                  onClick={handleSearchButton}
                  disabled={isSearching}
                >
                  {isSearching ? (
                    <span
                      className="spinner-border spinner-border-sm "
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <Icon.Search color="black" size={24} />
                  )}
                </button>
              </form>

              {/* Dropdown for Search Results */}
              {searchResults.products?.length > 0 ||
                searchResults.categories?.length > 0 ||
                searchResults.subcategories?.length > 0 ? (
                <div className="nav-search">
                  {/* Display filtered products */}
                  {searchResults?.products?.map((product) => (
                    <div
                      key={product?.id}
                      onClick={() => { handleSearch(""); navigate(`/product/${product.id}`); }}
                      className="search-item d-flex align-items-center"
                    >
                      {product.image && (
                        <img
                          src={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_product_IMAGE_URL}${product?.image}`}
                          alt={product?.title}
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      )}
                      <h6>
                        {product.title.split(" ").slice(0, 5).join(" ")}
                        {product.title.split(" ").length > 5 && "..."}
                      </h6>
                    </div>
                  ))}

                  {/* Display filtered categories */}
                  {searchResults?.categories?.map((category) => (
                    <div
                      onClick={() => {
                        navigate(`/search?result=category&id=${category?.id}`);
                        setSearchQuery("");
                        setSearchResults({
                          products: [],
                          categories: [],
                          subcategories: [],
                        });
                      }}
                      key={category?.id}
                      className="search-item d-flex align-items-center"
                    >
                      <span
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "5px",
                        }}
                      >
                        ➔ {/* Arrow icon */}
                      </span>
                      <h6>{category?.name}</h6>
                    </div>
                  ))}

                  {/* Display filtered subcategories */}
                  {searchResults?.subcategories?.map((subcategory) => (
                    <div
                      onClick={() => {
                        navigate(
                          `/search?result=subcategory&id=${subcategory.id}`
                        );
                        setSearchQuery("");
                        setSearchResults({
                          products: [],
                          categories: [],
                          subcategories: [],
                        });
                      }}
                      key={subcategory.id}
                      className="search-item d-flex align-items-center"
                    >
                      <span
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "5px",
                        }}
                      >
                        ➔ {/* Arrow icon */}
                      </span>
                      <h6>{subcategory.name}</h6>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>

            {/* Right Side Icons */}
            <div className="mx-2 d-flex align-items-center justify-content-center icons">
              {/* Login Section */}
              {auth.user === null ? (
                <Link to="/login" className="btn-sm me-3 btnlogin">
                  Login
                  <Icon.PersonCircle className="ms-2" />
                </Link>
              ) : (
                <div
                  className="user-profile me-3 border border-1 border-white"
                  variant="primary"
                  onClick={handleShow}
                >
                  <img
                    src={`${auth?.user?.profilePhoto == null
                      ? "https://pronedvizhimost.ru/static/custom/img/default/user.png"
                      : profileImage
                      }`}
                    className="w-100"
                    alt="Profile"
                    onError={(e) => {
                      e.target.src =
                        "https://pronedvizhimost.ru/static/custom/img/default/user.png";
                    }}
                  />
                </div>
              )}

              {/* Cart Section */}
              <Link to="/cart">
                <div className="position-relative ms-3 me-4">
                  {cart.length > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {cart.length}
                    </span>
                  )}
                  <Icon.Cart color="white" size={25} />
                </div>
              </Link>
            </div>

            {/* Menu Icon */}
            <Icon.List
              color="white"
              size={30}
              id="menu-btn"
              onClick={toggleMenu}
            />
          </div>
        </nav>
      </div>

      {/* Profile Details */}
      {auth.user != null && (
        <Offcanvas show={show} onHide={handleClose} placement={"end"}>
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mt-4 mx-auto potition-relative">
              <div className="user-profile-off">
                <img
                  src={`${auth.user.profilePhoto == null
                    ? "https://pronedvizhimost.ru/static/custom/img/default/user.png"
                    : profileImage
                    }`}
                  className="w-100"
                  alt="Profile"
                  onError={(e) => {
                    e.target.src =
                      "https://pronedvizhimost.ru/static/custom/img/default/user.png";
                  }}
                />
              </div>
              <div className="user-info text-center mt-3">
                <ul className="userdetails-sec">
                  <li>
                    <div>
                      <svg
                        width="40px"
                        height="40px"
                        viewBox="0 0 24 24"
                        fill="none"
                        className=" me-2"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.5 6L5.25 5.25H18L18.75 6V7.5H19.5L20.25 8.25V11.25V12V15.75V18.75L19.5 19.5H5.25L4.5 18.75V8.25V6ZM18.75 15.75H15.75C14.5074 15.75 13.5 14.7426 13.5 13.5C13.5 12.2574 14.5074 11.25 15.75 11.25H18.75V9H18H6V18H18.75V15.75ZM17.25 6.75V7.5H6V6.75H17.25ZM15 13.5C15 13.0858 15.3358 12.75 15.75 12.75H18.75V14.25H15.75C15.3358 14.25 15 13.9142 15 13.5Z"
                          fill="#080341"
                        />
                      </svg>
                      My Balance:
                    </div>
                    <span
                      style={{
                        backgroundColor: "#198754",
                        color: "#fff",
                        fontWeight: "bold",
                        padding: "0.25rem 0.5rem",
                        borderRadius: "0.25rem",
                        marginLeft: "0.5rem",
                      }}
                    >
                      ₹
                      {auth?.user?.walletBalance
                        ? auth.user.walletBalance
                        : "₹0"}
                    </span>
                  </li>
                  <li>
                    <p>See Pending Balance:</p>
                    <Link
                      to="/pending-balance"
                      onClick={() => setShow(false)}
                    >
                      <span
                        style={{
                          backgroundColor: "#198754",
                          color: "#fff",
                          fontWeight: "bold",
                          padding: "0.25rem 0.5rem",
                          borderRadius: "0.25rem",
                          marginLeft: "0.5rem",
                        }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          className=" me-2"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-arrow-right-icon lucide-arrow-right"
                        >
                          <path d="M5 12h14" />
                          <path d="m12 5 7 7-7 7" />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li className=" justify-content-center">
                    <h5 className="text-dark">{auth.user.name}</h5>
                  </li>
                  <li className=" justify-content-center">
                    <p>{auth.user?.email}</p>
                  </li>
                  <li className=" justify-content-center">
                    <p>Role: {auth.user.userType}</p>
                  </li>
                  <li>
                    <p>ReferalCode:</p>
                    <span className="text-bg-success px-2 py-1 rounded">
                      {auth?.user?.referral_code
                        ? auth.user.referral_code
                        : "N/A"}
                    </span>
                  </li>
                </ul>
                <section className="mb-3">
                  <Link
                    to="/dashboard"
                    onClick={() => setShow(false)}
                    className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0
                      ? "disabled"
                      : ""
                      }`}
                  >
                    Dashboard
                    <Icon.ClipboardData color="white" className="ms-2" />
                  </Link>
                </section>
                <section className="mb-3">
                  <Link
                    to="/userprofile"
                    onClick={() => setShow(false)}
                    className={`btn btn-dark probtn ${auth.user.isActive === 0 ? "disabled" : ""
                      }`}
                  >
                    Edit profile
                    <Icon.Pen color="white" className="ms-2" />
                  </Link>
                </section>
                {/* <section className='mb-3'>
                  <Link to={'/orders'} onClick={() => setShow(false)} className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0 ? 'disabled' : ''}`}>View Orders<Icon.Cart4 color='white' className='ms-2' /></Link>
                </section>


                {<section>
                  <Link to="/products" onClick={() => setShow(false)} className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0 ? 'disabled' : ''}`}>Products<Icon.Bag color='white' className='ms-2' /></Link>
                </section>} */}

                <section className="mb-3">
                  {userType === "admin" && (
                    <Link
                      to="/allorders"
                      onClick={() => setShow(false)}
                      className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0
                        ? "disabled"
                        : ""
                        }`}
                    >
                      View Orders
                      <Icon.Cart4 color="white" className="ms-2" />
                    </Link>
                  )}

                  {userType === "distributor" && (
                    <Link
                      to="/allorderofseller"
                      onClick={() => setShow(false)}
                      className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0
                        ? "disabled"
                        : ""
                        }`}
                    >
                      View Orders
                      <Icon.Cart4 color="white" className="ms-2" />
                    </Link>
                  )}

                  {userType === "user" && (
                    <Link
                      to="/orders"
                      onClick={() => setShow(false)}
                      className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0
                        ? "disabled"
                        : ""
                        }`}
                    >
                      View Orders
                      <Icon.Cart4 color="white" className="ms-2" />
                    </Link>
                  )}
                </section>

                {userType === "admin" || userType === "distributor" ? (
                  <section>
                    <Link
                      to="/products"
                      onClick={() => setShow(false)}
                      className={`btn btn-dark probtn ${auth.user.isActive === 2 || auth.user.isActive === 0
                        ? "disabled"
                        : ""
                        }`}
                    >
                      Products
                      <Icon.Bag color="white" className="ms-2" />
                    </Link>
                  </section>
                ) : (
                  ""
                )}

                {auth.user.isActive === 2 && (
                  <section className="my-4">
                    <h5 className="text-primary">Your account is pending!</h5>
                    <h6 className="text-secondary">
                      Please provide your details
                    </h6>
                    <h6>or</h6>
                    <h6 className="text-secondary">
                      Check your email for activation link
                    </h6>
                  </section>
                )}
                {auth.user.isActive === 0 && (
                  <section className="my-5">
                    <h5 className="text-muted">Your account is inactive!</h5>
                    <h6 className="text-muted">Please contact with us</h6>
                  </section>
                )}
                <section className="logout-btn text-center pt-4">
                  <button
                    onClick={handleLogout}
                    className="btn btn-danger probtn"
                  >
                    Log out
                    <Icon.Lock color="white" className="ms-2"></Icon.Lock>
                  </button>
                </section>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
};

export default Navbar;
